import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Priva
import { PrivaBffLoggedInUserGuard } from '@priva/auth/current-user';
import { PrivaAuthSignoutComponent } from '@priva/auth/signout';

// Shared
import { AppConfigurationResolver } from 'app/shared/app-configuration';
import { ErrorPagesProxyModule } from 'app/shared/routing-proxies';

import { AppMainComponent } from './app-main.component';
import { ReportDetailsModule } from './report-details/report-details.module';
import { ReportEditorModule } from './report-editor/report-editor.module';
// Routing children
import { ReportOverviewModule } from './report-overview/report-overview.module';
import { SmartInsightsModule } from './smart-insights/smart-insights.module';
import { UnsubscribeModule } from './unsubscribe';

const routes: Routes = [
    ErrorPagesProxyModule.defineRoute('error'),
    UnsubscribeModule.defineRoute('unsubscribe/:subscriptionId'),
    {
        path: '',
        resolve: {
            config: AppConfigurationResolver,
        },
        canActivate: [PrivaBffLoggedInUserGuard],
        component: AppMainComponent,

        children: [
            {
                path: 'signout',
                component: PrivaAuthSignoutComponent,
            },
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            ReportOverviewModule.defineRoute('home'),
            SmartInsightsModule.defineRoute('smart-insights'),
            ReportDetailsModule.defineRoute('report/:reportId'),
            ReportEditorModule.defineRoute('report/:reportId/edit'),
            {
                path: '**',
                redirectTo: '/error/not-found',
            },
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            paramsInheritanceStrategy: 'always',
        }),
    ],
    exports: [RouterModule],
    providers: [],
})
export class AppRoutingModule {}
